Ext.define('SA.lq.view.ConditionCmpFactory', {
    createCmp({listOperator, condition}) {
        var cmp = Ext.widget({xtype: 'lq-condition'}),
            attribute = SA.data.AttributesCache.getModel(condition.getAttributeId()),
            fieldFormatter = attribute.getValueFormatter(),
            attributeTextHtml = Ext.String.htmlEncode(attribute.getLabel()),
            attributeBadgesHtml = SA.AttributeBadges.getHtml({attribute: attribute.getId()}),
            attributeLabelHtml = `${attributeTextHtml} ${attributeBadgesHtml}`;

        this.setRefs(cmp);
        this.initState({cmp, attributeLabelHtml, listOperator, condition, fieldFormatter});
        this.bindEvents(cmp);

        return cmp;
    },

    bindEvents(cmp) {
        cmp.conditionOperatorCombo.on('change', (combo, value) => cmp.onOperatorComboChange(value));
        cmp.on('operatorComboChange', () => this.handlers.conditionOperatorComboChange());
        cmp.unaryField.on('change', () => this.handlers.fieldChange());
        cmp.gteField.on('change', () => this.handlers.fieldChange());
        cmp.lteField.on('change', () => this.handlers.fieldChange());
        cmp.removeBtn.on('click', () => this.handlers.removeClick(cmp));
        cmp.listOperatorCombo.on('change', value => this.handlers.listOperatorComboChange(value));
    },

    initState({cmp, attributeLabelHtml, listOperator, condition, fieldFormatter}) {
        cmp.attributeId = condition.getAttributeId();
        cmp.attributeLabelCmp.update(attributeLabelHtml);

        cmp.setListOperatorValue(listOperator);
        cmp.unaryField.setFormat(fieldFormatter);
        cmp.gteField.setFormat(fieldFormatter);
        cmp.lteField.setFormat(fieldFormatter);

        if (condition.isBetweenCondition()) {
            cmp.setIsBetweenCondition([condition.getGteOperand(), condition.getLteOperand()]);
        }
        else {
            cmp.setIsUnaryCondition({operator: condition.getOperator(), operand: condition.getOperand()});
        }
    },

    setHandlers(handlers) {
        this.handlers = handlers;
    },

    setRefs(cmp) {
        cmp.attributeLabelCmp = cmp.down('#attributeLabelCmp');
        cmp.conditionOperatorCombo = cmp.down('#conditionOperatorCombo');
        cmp.unaryField = cmp.down('#unaryField');
        cmp.betweenFieldsContainer = cmp.down('#betweenFieldsContainer');
        cmp.gteField = cmp.down('#gteField');
        cmp.lteField = cmp.down('#lteField');
        cmp.listOperatorCombo = cmp.down('#listOperatorCombo');
        cmp.removeBtn = cmp.down('#removeBtn');
    }
});